import axios from "axios";
import { useEffect, useState } from "react";
import { FaEnvelope, FaShareAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import NotFound from "../shared/NotFound";

interface JobDetail {
    id: string;
    job_opening: string;
    experience: string;
    department: string;
    qualification: string[];
    requirement: string[];
    created_at: string;
    updated_at: string;
    start_date: string;
    end_date: string;
    phone: string;
    email: string;
    address: string;
}

export default function Detail() {
    const [data, setData] = useState<JobDetail | null>(null);
    const navigate = useNavigate();

    const getData = async () => {
        const name = window.location.pathname.split("/").pop();
        try {
            const response = await axios.get(process.env.REACT_APP_API_ENDPOINT + "/job/get-by-name?job_opening=" + name);
            if (response.data && response.data.data) {
                setData(response.data.data);
            } else {
                navigate("/404");
            }
        } catch (error) {
            console.log(error);
            navigate("/404");
        }
    };

    const handleCopyLink = (search: string) => {
        const linkToCopy = `${window.location.origin}${window.location.pathname}`;

        navigator.clipboard.writeText(linkToCopy)
            .then(() => alert("URL berhasil disalin!"))
            .catch((error) => console.error("Gagal menyalin URL:", error));
    };

    useEffect(() => {
        getData();
    }, []);

    return (
        <div className="max-w-screen-2xl mx-auto pb-60 p-5 lg:p-16">
            {data ? (
                <>
                    <div className="flex flex-col lg:flex-row items-center justify-between mb-11">
                        <h2 className="text-xl font-poppinsBold text-center lg:text-left">DETAIL LOWONGAN</h2>
                        <button
                            onClick={() => handleCopyLink(data.job_opening)}
                            className="mt-3 lg:mt-0 flex items-center gap-2 text-sm text-blue-700 hover:text-blue-900 transition"
                            title="Bagikan lowongan ini"
                        >
                            <FaShareAlt size={18} />
                            <span>Bagikan</span>
                        </button>
                    </div>
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                        <div className="lg:col-span-2 bg-gray-100 p-6 rounded-lg shadow-md">
                            <h2 className="text-2xl font-bold font-poppinsRegular text-blue-700 mb-4">{data.job_opening}</h2>
                            <p className="text-gray-700 leading-relaxed font-poppinsRegular">
                                Pengalaman: <span className="font-semibold">{data.experience}</span>
                            </p>
                            <p className="text-gray-700 leading-relaxed font-poppinsRegular">
                                Departemen: <span className="font-semibold">{data.department}</span>
                            </p>
                            <h3 className="text-lg font-bold text-blue-700 mt-6 mb-2 font-poppinsRegular">Kualifikasi</h3>
                            <ul className="text-gray-700 list-decimal list-inside font-poppinsRegular">
                                {data.qualification.map((qual, index) => (
                                    <li key={index}>{qual}</li>
                                ))}
                            </ul>
                        </div>

                        <div className="space-y-6 font-poppinsRegular">
                            <div className="bg-gray-100 p-6 rounded-lg shadow-md">
                                <h3 className="text-lg font-bold text-blue-700 mb-2">Tanggal Pendaftaran</h3>
                                <p className="text-gray-700">
                                    {new Intl.DateTimeFormat('id-ID', { day: 'numeric', month: 'long', year: 'numeric' }).format(new Date(data.start_date))} - {new Intl.DateTimeFormat('id-ID', { day: 'numeric', month: 'long', year: 'numeric' }).format(new Date(data.end_date))}
                                </p>
                            </div>

                            <div className="bg-gray-100 p-6 rounded-lg shadow-md">
                                <h3 className="text-lg font-bold text-blue-700 mb-2">Persyaratan</h3>
                                <ol className="text-gray-700 list-disc list-inside">
                                    {data.requirement.map((req, index) => (
                                        <li key={index}>{req}</li>
                                    ))}
                                </ol>
                            </div>
                        </div>

                        <div className="lg:col-span-2 bg-gray-100 p-6 rounded-lg shadow-md font-poppinsRegular">
                            <h2 className="text-2xl font-bold text-blue-700 mb-4">Cara Melamar</h2>

                            <p className="text-gray-700 mb-4">
                                Kirim berkas lamaran Anda ke alamat berikut:
                            </p>
                            <div className="bg-white p-4 rounded-lg shadow-sm mb-4">
                                <a
                                    href={`https://www.google.com/maps/search/?api=1&query=${data?.address}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-600 hover:underline"
                                >
                                    {data?.address}
                                </a>
                            </div>

                            <p className="text-gray-700 mb-4">
                                Info lebih lanjut hubungi kami melalui WhatsApp di nomor berikut:
                            </p>
                            <a
                                href={`https://wa.me/62${data?.phone}?text=Halo,%20saya%20tertarik%20melamar%20untuk%20posisi%20${data?.job_opening}%20di%20perusahaan%20Anda.`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="bg-green-500 text-white font-bold py-2 px-4 rounded-lg shadow-md hover:bg-green-600 transition-colors inline-block mb-4"
                            >
                                Hubungi via WhatsApp
                            </a>
                            <p className="text-gray-700 mb-4">
                                Atau kirimkan berkas lamaran melalui email:
                            </p>
                            <div className="flex items-center space-x-2">
                                <FaEnvelope className="text-blue-600" size={20} />
                                <a
                                    href={`mailto:${data?.email}`}
                                    target="_blank"
                                    className="text-blue-600 hover:underline"
                                >
                                    {data?.email}
                                </a>
                            </div>
                        </div>
                    </div>
                </>

            ) : (
                <NotFound></NotFound>
            )}
        </div>
    );
}
